import { useState, useCallback } from 'react'
import { emptyFunction } from 'utils'

export const useDropdownState = (
  openDropdownCallback = emptyFunction,
  closeDropdownCallback = emptyFunction
) => {
  const [isOpen, setIsOpen] = useState(false)

  const openDropdown = useCallback(() => {
    if (!isOpen) {
      setIsOpen(true)
      openDropdownCallback?.()
    }
  }, [isOpen, openDropdownCallback])

  const closeDropdown = useCallback(() => {
    if (isOpen) {
      setIsOpen(false)
      closeDropdownCallback?.()
    }
  }, [isOpen, closeDropdownCallback])

  const toggleDropdown = useCallback(() => {
    if (!isOpen) {
      openDropdown()
    } else {
      closeDropdown()
    }
  }, [isOpen, openDropdown, closeDropdown])

  return { isOpen, openDropdown, closeDropdown, toggleDropdown }
}
